export default __webpack_public_path__ + "static/media/rodoshi.3cbf6520.jpg";